// DESCRIPTION: Attributes related models & functions
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.AttributesNormalize = this.HyperMD.AttributesNormalize || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Walks through attribute keys and makes them snakeCase if needed
     * @param attributes
     */
    function default_1(attributes) {
        if (typeof attributes !== "object") {
            return {};
        }
        var changed = false;
        var result = __assign({}, attributes);
        for (var key in attributes) {
            if (attributes.hasOwnProperty(key)) {
                var normalizedKey = key; //snakeCase(key);
                if (normalizedKey !== key) {
                    result[normalizedKey] = result[key];
                    delete result[key];
                    changed = true;
                }
            }
        }
        return changed ? result : attributes;
    }
    exports.default = default_1;
});
